import { createAsyncThunk } from "@reduxjs/toolkit";
import UsersAPI, { User, UserGroupName } from "../../../api/Users";
import { RootState } from "../../../../src/app/store";

export const fetchUsersWithUserIds = createAsyncThunk<
  User[],
  string[],
  { state: RootState; rejectValue: string }
>(
  "users/fetchUsersWithUserIds",
  async (userIds, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const existingEntities = state.users.users.entities;

      const missingUserIds = userIds.filter((id) => !existingEntities[id]);

      if (missingUserIds.length === 0) {
        return [];
      }

      const fetchedUsers = await UsersAPI.get_users_with_user_ids(
        missingUserIds
      );

      return fetchedUsers;
    } catch (error: any) {
      return rejectWithValue("Failed to fetch data");
    }
  }
);

export const fetchUsersWithEmailIds = createAsyncThunk<
  User[],
  string[],
  { state: RootState; rejectValue: string }
>(
  "users/fetchUsersWithEmailIds",
  async (emailIds, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const existingEmailMap = state.users.emailIdMap;

      const missingEmailIds = emailIds.filter(
        (email) => !existingEmailMap[email]
      );

      if (missingEmailIds.length === 0) {
        return [];
      }

      const fetchedUsers = await UsersAPI.get_users_with_email_ids(
        missingEmailIds
      );

      return fetchedUsers;
    } catch (error: any) {
      return rejectWithValue("Failed to fetch data");
    }
  }
);

export const fetchConveners = createAsyncThunk<
  User[],
  void,
  { rejectValue: string }
>(
  "users/fetchConveners",
  async (_, { rejectWithValue }) => {
    try {
      return await UsersAPI.getUsersByGroup(
        UserGroupName.CONVENERS
      );
    } catch (error) {
      return rejectWithValue("Failed to fetch conveners");
    }
  }
);

export const fetchCommitteeMembers = createAsyncThunk<
  User[],
  void,
  { rejectValue: string }
>(
  "users/fetchCommitteeMembers",
  async (_, { rejectWithValue }) => {
    try {
      return await UsersAPI.getUsersByGroup(
        UserGroupName.COMMITTEE_MEMBERS
      );
    } catch (error) {
      return rejectWithValue("Failed to fetch committee members");
    }
  }
);

export const fetchDealingOfficers = createAsyncThunk<
  User[],
  void,
  { rejectValue: string }
>("users/fetchDealingOfficers", async (_, { rejectWithValue }) => {
  try {
    return await UsersAPI.getUsersByGroup(
      UserGroupName.DEALING_OFFICERS,
    );
  } catch (error) {
    return rejectWithValue("Failed to fetch Dealing Officers");
  }
});

export const fetchIOAppointingAuthorities = createAsyncThunk<
  User[],
  void,
  { rejectValue: string }
>(
  "users/fetchIOAppointingAuthorities",
  async (_, { rejectWithValue }) => {
    try {
      return await UsersAPI.getUsersByGroup(
        UserGroupName.IO_APPOINTING_AUTHORITIES
      );
    } catch (error) {
      return rejectWithValue("Failed to fetch IO Appointing Authorities");
    }
  }
);
 

export const fetchForwardingAuthorities = createAsyncThunk<
  User[],
  void,
  { rejectValue: string }
>(
  "users/fetchForwardingAuthorities",
  async (_, { rejectWithValue }) => {
    try {
      return await UsersAPI.getUsersByGroup(
        UserGroupName.FORWARDING_AUTHORITIES
      );
    } catch (error) {
      return rejectWithValue("Failed to fetch Forwarding Authorities");
    }
  }
);

